import { cva } from '@/styled-system/css';

// Give center slide a higher z-index than other slides to avoid flickering in transitions
export const photoCarouselSlideRecipe = cva({
  base: {
    'inset': '0',
    'position': 'absolute',

    '& > a': {
      display: 'block',
      height: '100%',
    },

    // Adjacent slides are `visibility: hidden` so their content is unreachable by
    // screen readers and by Tab [CDS-5857]. A swipe has to show them, so the
    // container un-hides them for the duration of the gesture. They stay
    // `aria-hidden` and `inert` throughout — this is a purely visual exception.
    '[data-swiping] &': {
      visibility: 'visible',
    },
  },
  variants: {
    shouldAnimateTranslations: {
      true: {
        /*
         * `visibility` is animatable with a special interpolation: during a transition it
         * resolves to `visible` whenever *either* endpoint is `visible`. So the shared
         * duration gives us both halves of what we need — the outgoing slide stays
         * visible for the whole slide-out and only then flips to `hidden`, while the
         * incoming slide becomes visible immediately.
         */
        transitionProperty: {
          _motionReduce: 'none',
          _motionSafe: 'transform, visibility',
        },
        transitionDuration: {
          _motionReduce: '0s',
          _motionSafe: '{durations.200}',
        },
        transitionTimingFunction: 'cubic-bezier(0.58, 0.92, 0.57, 0.92)',
      },
      false: {},
    },
    slidePosition: {
      center: {
        transform: 'translateX(0%)',
        visibility: 'visible',
        zIndex: 2,
      },
      left: {
        transform: 'translateX(-100%)',
        visibility: 'hidden',
        zIndex: 1,
      },
      right: {
        transform: 'translateX(100%)',
        visibility: 'hidden',
        zIndex: 1,
      },
    },
  },
});
